export default {
  items: [],
  pagination: {},
  isBusy: false,
  size: 15,
};
